import { ListChecks, BadgeCheck, Zap, ReceiptText } from "lucide-react";

const CompanyInformationInfoCardContent = () => {
  return (
    <div className="flex flex-col gap-8 text-left">
      <h1 className="w-full text-white text-base">How it works</h1>
      <div className="flex flex-row gap-4 self-stretch">
        <ListChecks
          size={36}
          stroke="white"
          className="min-h-9 min-w-9 aspect-square border-2 border-white rounded-lg"
        />
        <div className="flex flex-col gap-1">
          <h2 className="w-full text-white text-xl font-bold">
            Share your needs
          </h2>
          <p className="w-full text-white opacity-70 text-base">
            Tell our team the role, scope, and outcomes you’re looking for.
          </p>
        </div>
      </div>

      <div className="flex flex-row gap-4 self-stretch">
        <BadgeCheck
          size={36}
          stroke="white"
          className="min-h-9 min-w-9 aspect-square"
        />
        <div className="flex flex-col gap-1">
          <h2 className="w-full text-white text-xl font-bold">
            We source and vet
          </h2>
          <p className="w-full text-white opacity-70 text-base">
            We match you with pre-vetted senior leaders based on your goals and
            stage.
          </p>
        </div>
      </div>

      <div className="flex flex-row gap-4 self-stretch">
        <Zap
          size={36}
          stroke="white"
          className="min-h-9 min-w-9 aspect-square border-2 border-white rounded-full"
        />
        <div className="flex flex-col gap-1">
          <h2 className="w-full text-white text-xl font-bold">
            Hire the perfect fit, 3x faster
          </h2>
          <p className="w-full text-white opacity-70 text-base">
            Review profiles, interview top candidates, and hire the best, all in
            just days.
          </p>
        </div>
      </div>

      <div className="flex flex-row gap-4 self-stretch">
        <ReceiptText
          size={36}
          stroke="white"
          className="min-h-9 min-w-9 aspect-square"
        />
        <div className="flex flex-col gap-1">
          <h2 className="w-full text-white text-xl font-bold">
            We handle the paperwork
          </h2>
          <p className="w-full text-white opacity-70 text-base">
            Contracts, payroll, and compliance run through us. You pay Venturous
            directly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompanyInformationInfoCardContent;
